import { WebRTCEncoderSettings } from '@/types/users'
import { KeyDict } from '@/types'
import { Stream } from '@/types/streams'

export enum MemberRole {
  Admin = 'admin',
  Member = 'member',
  GuestCaster = 'guestcaster',
  Guest = 'guest'
}

export interface TeamMember {
  role: MemberRole,
  id?: string,
  team_id?: string,
  teamid?: string, // depricated
  name?: string,
  first_name?: string,
  last_name?: string,
  user_id?: string,
  encoderSettings?: WebRTCEncoderSettings,
  teams?: { [id: string]: boolean },
}

export interface FaceBookPage {
  id: string,
  name: string,
  usertoken: string
}

export interface StreamsAuth {
  login?: string,
  password_hash?: string,
  pending?: boolean,
  error?: string
}

export interface TeamGroup {
  id?: string,
  team_id: string,
  name: string,
  description?: string,
  members?: string[]
}

export interface Team {
  id: string,
  cast_template?: string,
  default_template?: string,
  default_layout?: string,
  high_quality_casters?: boolean,
  default_region?: string,
  deleted: boolean,
  ftp_asset_pass?: string,
  minimal_commentators?: boolean,
  cef_nobroadcast_final?: boolean,
  k360_channel_id: number,
  largemachine_allowed?: boolean,
  members: KeyDict<TeamMember>,
  name: string,
  logo?: string,
  facebook: KeyDict<FaceBookPage>,
  lastEventTimestamp?: number,
  version: string,
  entity: string | null, // ordway entity,
  customer_id: string | null,
  streams?: Stream[],
  streams_auth?: KeyDict<StreamsAuth>,
  features?: TeamFeatures
}

export interface TeamFeatures {
  selfServe: TeamFeatureConfig
}

export interface TeamFeatureConfig {
  enabled: boolean
}

export interface MemberInvite {
  email: string,
  email_sent: boolean,
  role: MemberRole,
  sent_from: string,
  signup_complete: boolean,
  team_id: string,
  id: string
}
